// extracted by mini-css-extract-plugin
module.exports = {"colivingMenu":"coliving-menu-module--colivingMenu--3FMCG","menuItem":"coliving-menu-module--menuItem--1DbFy","menuLink":"coliving-menu-module--menuLink--3Vs3_"};